import { Button, ButtonWrapper, IconWrapper, Label } from './styles';

export type DietaryButtonProps = {
  filterTag: string;
  icon: JSX.Element;
  selected: boolean;
  onClick: () => void;
  flexDirection?: 'row' | 'column';
};

export const DietaryButton: React.FC<DietaryButtonProps> = ({
  filterTag,
  icon,
  selected,
  onClick,
  flexDirection,
}): JSX.Element => (
  <Button selected={selected} onClick={onClick}>
    <ButtonWrapper flexDirection={flexDirection}>
      <IconWrapper>{icon}</IconWrapper>
      <Label>{filterTag}</Label>
    </ButtonWrapper>
  </Button>
);
